export const emitterProps = {
  wishlist: {
    add: 'wishlist:add',
    remove: 'wishlist:remove',
  }
}

type EmitterCallback = (payload: any) => void

class GlobalEmitter {
  private listeners = new Map<string, WeakMap<EmitterCallback, EventListener>>()

  emit (name: string, payload = {}) {
    const event = new CustomEvent(name, {
      detail: payload
    })
    document.dispatchEvent(event)
  }

  on (name: string, callback: EmitterCallback) {
    const wrappedListener: EventListener = (e) => {
      // @ts-ignore
      callback(e.detail)
    }

    let eventListeners = this.listeners.get(name)

    if (!eventListeners) {
      eventListeners = new WeakMap<EmitterCallback, EventListener>()
      this.listeners.set(name, eventListeners)
    }

    eventListeners.set(callback, wrappedListener)
    document.addEventListener(name, wrappedListener)

    return () => {
      this.off(name, callback)
    }
  }

  off (name: string, callback: EmitterCallback) {
    const wrappedListener = this.listeners.get(name)?.get(callback)

    if (!wrappedListener) {
      return
    }

    document.removeEventListener(name, wrappedListener)
    this.listeners.get(name)?.delete(callback)
  }
}

export const globalEmitter = new GlobalEmitter()
